import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';
import { DeliveryStatus } from '../../../../../constants/status';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2/delivery';

async function auctionApprove(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/approve`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function auctionReject(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/reject`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function addFund(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/fund/add`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function clientFundSettle(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/fund/client-settle`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getDeliveryGroups(filters) {
  const mappedFilters = { ...filters };

  if (filters.status) {
    mappedFilters.status = DeliveryStatus[filters.status];
  }

  const query = new URLSearchParams(mappedFilters).toString();
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/groups?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getDeliveryAuctions(filters) {
  const { groupId, ...otherFilters } = filters;

  const mappedFilters = { ...otherFilters };

  if (filters.status) {
    mappedFilters.status = DeliveryStatus[filters.status];
  }

  const query = new URLSearchParams(mappedFilters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/auctions/${groupId}?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}


export const checkDiscountEligibility = async (params) => {
  const config = {
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + user.token },
    params,
  };
  try {
    const response = await axios.get(`${endpoint}/auction-discount/check`, config);
    return response.data;
  } catch (error) {
    console.error('Error checking discount eligibility:', error);
    throw error;
  }
};

export const applyDiscount = async (formData) => {
  const config = {
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + user.token },
  };
  try {
    const response = await axios.post(`${endpoint}/auction-discount/apply`, formData, config);
    return response.data;
  } catch (error) {
    console.error('Error applying discount:', error);
    throw error;
  }
};

export async function removeDiscount(auctionId, remarks = '') {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(
      `${endpoint}/auction-discount/remove`,
      { auction: auctionId, remarks },
      config
    );
    return response;
  } catch (error) {
    return { success: false, message: error.response?.data?.message || 'Failed to remove discount' };
  }
}

export {
  addFund,
  getDeliveryGroups,
  getDeliveryAuctions,
  auctionApprove,
  auctionReject,
  clientFundSettle,
};
